import { formsManager } from './form';
import { formulaVisualManager } from './formula-visual';
class FormuleFormManager {
    formSelector = '.js-FormuleForm';
    init() {
        const forms = $(this.formSelector);
        if (forms.length === 0)
            return;
        forms.each((_, element) => {
            const form = formsManager.initForm(element);
            this.applyAfterSubmitCallback(form);
        });
    }
    applyAfterSubmitCallback(form) {
        const contentSelector = '.Container-Content';
        const container = form.container.parent(contentSelector);
        form.container.data('onSubmitted', (result) => {
            formsManager.removeForm(form);
            const content = $(result).find(contentSelector).html();
            $(container).css({ display: 'none' });
            $(container).html(content);
            const formElement = $(container).find(this.formSelector);
            if (content && formElement.length === 1) {
                const newForm = formsManager.initForm(formElement.get(0));
                this.applyAfterSubmitCallback(newForm);
                formulaVisualManager.init();
            }
            $(container).fadeIn(500);
        });
    }
}
const formuleFormManager = new FormuleFormManager();
export { FormuleFormManager, formuleFormManager };
